export const getCountryFromCoords = (
  coords: mapkit.Coordinate,
  setter: (c: string | undefined) => void
): void => {
  return; // remove if want to add back in reverse lookup

  const geocoder = new mapkit.Geocoder({
    language: 'en-GB',
  });

  geocoder.reverseLookup(coords, (err, data) => {
    if (err) return;
    if (data.results.length > 0) {
      setter((data.results[0] as any).country);
      return;
    }
  });
};
